<app-top-navbar></app-top-navbar>
<app-home *ngIf="display_home"></app-home>
<div [ngClass]="{'top-spacing': !display_home}" class="clearfix public-IM"><router-outlet></router-outlet></div>
